// React
import React, { useState, useEffect, useRef, useCallback } from "react";

// Ionic
import {
  IonLabel,
  IonItem,
  IonContent,
  IonHeader,
  IonToolbar,
  IonButton,
  IonIcon,
  IonCheckbox,
  IonRange,
  IonRadio,
  IonRadioGroup,
  IonModal,
  IonAccordion,
  IonAccordionGroup,
  IonRow,
  IonCol,
  IonLoading,
} from "@ionic/react";

import {
  options,
  closeOutline,
  informationCircleOutline,
  add,
  search,
} from "ionicons/icons";

import Constants from "../../Context/constants";
import { fetchMinimalDataWithFilter, isFilterSet } from "../../Context/filter.service";

import userService from "../../Context/user.service";
import { act } from "react-dom/test-utils";
//CSS

function Filter(props) {

  // Modal dunctions
  const modal = useRef(null);
  const input = useRef(null);
  const [isLoaded, setIsLoaded] = useState(true);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [activePlusFilter, setActivePlusFilter] = useState();
  const [minimalData, setMinimalData] = useState([]);
  const [searchRunning, setSearchRunning] = useState(false);
  const [resetCounter, setResetCounter] = useState(0);
  // Use the showNoResults from parent (Route.js) instead of local state
  // const [showNoResults, setShowNoResults] = useState(false);
  const callCounterRef = useRef({});
  const eventTimeoutRef = useRef({});

  let resetCounterPrev = 0;


  // Helper function to update filter and fetch new minimal data

  const updateFilterAndFetchData = (newFilter,context="") => {
    // Create a unique key for this exact call
    const callKey = JSON.stringify({filter: newFilter, context, timestamp: Date.now()});
    
    // Check if we've already processed this exact call in the last 100ms
    const now = Date.now();
    const recentCalls = Object.keys(callCounterRef.current).filter(key => {
      const callTime = callCounterRef.current[key];
      return (now - callTime) < 100;
    });
    
    // If we have the same context in recent calls, skip this one
    const sameContextCalls = recentCalls.filter(key => key.includes(`"context":"${context}"`));
    if (sameContextCalls.length > 0) {
      //console.log(`=== SKIPPING DUPLICATE - ${context} already called recently ===`);
      return;
    }
    
    // Record this call
    callCounterRef.current[callKey] = now;
    
    // Clean up old calls to prevent memory leak
    Object.keys(callCounterRef.current).forEach(key => {
      if (now - callCounterRef.current[key] > 1000) {
        delete callCounterRef.current[key];
      }
    });
    
    setSearchRunning(true);
    props.setActiveFilter(newFilter);
    
    setTimeout(() => {
      fetchMinimalDataWithFilter(
        newFilter,
        Constants.routeDefaultValueFilter,
        (minData) => {
          setMinimalData(minData.data);
          window.minData = minData.data;
          
          // Check if no items found
          if (props.setShowNoResults) {
            props.setShowNoResults(minData.data && Array.isArray(minData.data) && minData.data.length === 0);
          }
          
          // Defer parent callback to prevent render interference
          requestAnimationFrame(() => {
            if (props.onMinimalDataUpdate) {
              props.onMinimalDataUpdate(minData.data);            
            }
            setSearchRunning(false);
          });
        },
        (error) => {
          console.log(error);
          requestAnimationFrame(() => {
            setSearchRunning(false);
          });
        }
      );
    }, 150);
  };

  /*
  useEffect(() => {
    // Force a re-render of the filter state to ensure IonRange components display correctly
    const timer = setTimeout(() => {
      props.setActiveFilter({...props.activeFilter});
      setIsLoaded(true);
    }, 0);
    
    return () => clearTimeout(timer);
  }, []);
  */

  // Force re-render of IonRange components when modal opens
  useEffect(() => {
    if (filterModalOpen) {
      // Small delay to ensure modal is fully rendered before updating state
      const timer = setTimeout(() => {
        props.setActiveFilter({...props.activeFilter});
      }, 50);
      
      return () => clearTimeout(timer);
    }
  }, [filterModalOpen]);

  // Log filter changes to debug reset behavior
  useEffect(() => {
    //console.log("Filter state updated:", props.activeFilter);
  }, [props.activeFilter]);

  function onWillDismiss() {
    setFilterModalOpen(false);
  }

  function howtogetpro() {
    if (typeof window.parent.setPaywallModal !== "undefined") {
      window.parent.setPaywallModal("pro");
    }
  }

  function resetFilter() {
    props.setDog(false);
    props.setDisposal(false);
    props.setForfree(false);
    props.setShowNoResults(false);
    
    // Create complete reset filter
    const resetFilter = {
      ...Constants.routeDefaultValueFilter,
      gespanneErlaubt: false,
      voucher: false,
      typePitchEntsorgung: false
    };
    setSearchRunning(true);
    // Apply the reset immediately and force re-render
    props.setActiveFilter(resetFilter);
    setResetCounter(resetCounterPrev => resetCounterPrev + 1);
    
    // Use a slightly longer timeout to ensure state has updated
    setTimeout(() => {
      
      fetchMinimalDataWithFilter(
        resetFilter,
        Constants.routeDefaultValueFilter,
        (minData) => {
          setMinimalData(minData.data);
          window.minData = minData.data;
          
          // Check if no items found
          if (props.setShowNoResults) {
            props.setShowNoResults(minData.data && Array.isArray(minData.data) && minData.data.length === 0);
          }
          
          requestAnimationFrame(() => {
            if (props.onMinimalDataUpdate) {
              props.onMinimalDataUpdate(minData.data);            
            }
            setSearchRunning(false);
          });
        },
        (error) => {
          console.log(error);
          requestAnimationFrame(() => {
            setSearchRunning(false);
          });
        }
      );
    }, 100);
  }

  function prepareFilter() {
    setFilterModalOpen(true);
  }

  function closeModalFilter() {
    setFilterModalOpen(false);
  }

  function setDog() {
    if (props.dogValue === false) {
      props.setDog(true);
      updateFilterAndFetchData({ ...props.activeFilter, features: [...props.activeFilter.features, "Hunde erlaubt"] }, "dog");
    }
    else{
      props.setDog(false);
      updateFilterAndFetchData({ ...props.activeFilter, features: props.activeFilter.features.filter(f => f !== "Hunde erlaubt") }, "dog");
    }
  }

  function setDisposal() {
    if (props.disposalValue === false) {
      props.setDisposal(true);
      updateFilterAndFetchData({ ...props.activeFilter, typePitchEntsorgung: true,features: [...props.activeFilter.features, "Frischwasser", "Chemietoiletten-Entsorgung", "Grauwasser-Entsorgung"] }, "disposal");
    } else {
      props.setDisposal(false);
      updateFilterAndFetchData({ ...props.activeFilter, typePitchEntsorgung: false,features: props.activeFilter.features.filter(f => f !== "Frischwasser" && f !== "Chemietoiletten-Entsorgung" && f !== "Grauwasser-Entsorgung") }, "disposal");
    }
  }

  function setForfree() {
    if (props.forfreeValue === false) {
      props.setForfree(true);
      updateFilterAndFetchData({ ...props.activeFilter, price: { lower: 0, upper: 0 } }, "forfree");
    } else {
      props.setForfree(false);
      updateFilterAndFetchData({ ...props.activeFilter, price: { lower: 0, upper: 30 } }, "forfree");
    }
  }

  return isLoaded ? (
    <div>
      <IonRow className="ion-align-items-center">
        <IonCol>

          <>
            <IonButton
                size="small"
                className="filter__button font__icon "
                onClick={props.isProValue ? setDog : howtogetpro}
                value="dog"
                active="false"
                color={props.dogValue ? "secondary" : "light"}
            >
              <span className="filter__button__icon">h</span>
            </IonButton>

            <IonButton
                size="small"
                className="filter__button"
                onClick={props.isProValue ? setDisposal : howtogetpro}
                value="disposal"
                active="false"
                color={props.disposalValue ? "secondary" : "light"}
            >
              VE
            </IonButton>
            <IonButton
                size="small"
                className="filter__button"
                onClick={setForfree}
                value="forfree"
                active="false"
                color={props.forfreeValue ? "secondary" : "light"}
            >
              Gratis
            </IonButton>
          </>
          
        </IonCol>
        <IonCol size="auto" className="ion-text-end">
          {(function () {
            if(window.location.href.indexOf("typ=Entsorgungsstation") === -1) {
              if (props.isProValue) {
                var buttonColor = 'light';
                var iconColor = 'medium';
                if (props.filterIsSet() === true) {
                  buttonColor = 'secondary';
                  iconColor = 'light';
                }
                var buttonActive = props.filterIsSet();
                return (
                    <IonButton
                        size="small"
                        className="filter__button filter__modal"
                        id="open-filter-modal"
                        color={buttonColor}
                        active={buttonActive}
                        onClick={(e) => prepareFilter()}
                    >
                      <IonIcon icon={options} color={iconColor}/>
                    </IonButton>
                );
              } else {
                return (
                    <IonButton
                        size="small"
                        className="filter__button filter__modal"
                        id="dont-open-filter-modal"
                        color="light"
                        onClick={(e) => howtogetpro()}
                    >
                      <IonIcon icon={options} color="medium"/>
                    </IonButton>
                );
              }
            }
          })()}
        </IonCol>
      </IonRow>

      <div className={`${props.isProValue ? "show" : "hide"}`}>
          <IonModal
            isOpen={filterModalOpen}
            id="filtermodal"
            onWillDismiss={(ev) => onWillDismiss(ev)}
          >
            <IonHeader>
              <IonToolbar>
                <h4 className="ion-padding-start">Stellplätze filtern</h4>
                
                <IonButton
                  onClick={() => setFilterModalOpen(false)}
                  slot="end"
                  fill="clear"
                >
                  <IonIcon icon={closeOutline} />
                </IonButton>
              </IonToolbar>
            </IonHeader>

            <IonLoading
              isOpen={searchRunning}
              spinner="crescent"
              message="Bitte warten..."
              backdropDismiss={false}
            />

            <IonContent className="ion-padding" key={`${resetCounter}-${JSON.stringify(props.activeFilter.features)}`}>

              {/* No results notice */}
              {props.showNoResults && (
                <div style={{
                  backgroundColor: '#fff3cd',
                  border: '1px solid #ffeaa7',
                  borderRadius: '4px',
                  padding: '8px 12px',
                  display: 'flex',
                  alignItems: 'center',
                  color: '#856404'
                }}>
                  <IonIcon icon={informationCircleOutline} style={{ marginRight: '8px', color: '#f39c12' }} />
                  <span style={{ fontSize: '14px' }}>Keine Stellplätze mit den aktuellen Filterkriterien gefunden.</span>
                </div>
              )}
              
              <IonButton
                  size="small"
                  className="filter__button"
                  value="reset"
                  id="reset-search"
                  color={props.filterIsSet() ? "secondary" : "light"}
                  active={props.filterIsSet()}
                  disabled={!props.filterIsSet()}
                  onClick={() => resetFilter()}
              >
                Filter zurücksetzen
              </IonButton>

              <IonItem key="type-pitch" className="filter__item__accordion">
                <IonCheckbox
                  checked={props.activeFilter.typePitch}
                  name="type-pitch"
                  value="type-pitch"
                  onIonChange={(e) => {
                    if (props.activeFilter.typePitch && !e.detail.checked) {
                      updateFilterAndFetchData({ ...Constants.routeDefaultValueFilter, typePitch: false, typeService:props.activeFilter.typeService }, "typePitchReset");
                    } else {
                      updateFilterAndFetchData({ ...props.activeFilter, typePitch: !props.activeFilter.typePitch }, "typePitch");
                    }
                  }}
                ></IonCheckbox>
                <IonLabel className="ion-padding-start">
                  Wohnmobilstellplätze
                </IonLabel>
              </IonItem>

              <IonItem key="type-pitch-entsorgung" className={`filter__item__accordion ion-padding-start ${!props.activeFilter.typePitch ? 'item-disabled' : ''}`}>
                <IonCheckbox
                    checked={props.activeFilter.typePitchEntsorgung}
                    disabled={!props.activeFilter.typePitch}
                    name="type-pitch-entsorgung"
                    value="type-pitch-entsorgung"
                    onIonChange={(e) => {
                      const isChecked = e.detail.checked;
                      let newFeatures = [...props.activeFilter.features];
                      
                      if (isChecked) {
                        // Add disposal features if not already present
                        if (newFeatures.indexOf("Chemietoiletten-Entsorgung") === -1) {
                          newFeatures.push("Chemietoiletten-Entsorgung");
                        }
                        if (newFeatures.indexOf("Grauwasser-Entsorgung") === -1) {
                          newFeatures.push("Grauwasser-Entsorgung");
                        }
                      } else {
                        // Remove disposal features
                        newFeatures = newFeatures.filter(f => f !== "Chemietoiletten-Entsorgung" && f !== "Grauwasser-Entsorgung");
                      }
                      
                      updateFilterAndFetchData({ 
                        ...props.activeFilter, 
                        typePitchEntsorgung: isChecked,
                        features: newFeatures
                      }, "typePitchEntsorgung");
                    }}
                ></IonCheckbox>
                <IonLabel className="ion-padding-start">
                  mit Entsorgung
                </IonLabel>
              </IonItem>

              <IonItem key="type-voucher" className={`filter__item__accordion ion-padding-start ${!props.activeFilter.typePitch ? 'item-disabled' : ''}`}>
                <IonCheckbox
                    checked={props.activeFilter.voucher}
                    disabled={!props.activeFilter.typePitch}
                    name="type-voucher"
                    value="type-voucher"
                    onIonChange={(e) => {
                      updateFilterAndFetchData({ ...props.activeFilter, voucher: !props.activeFilter.voucher }, "voucher");
                    }}
                ></IonCheckbox>
                <IonLabel className="ion-padding-start">
                  mit BORDATLAS-Gutschein
                </IonLabel>
              </IonItem>

              <IonItem key="gespanneErlaubt" className={`filter__item__accordion ion-padding-start ${!props.activeFilter.typePitch ? 'item-disabled' : ''}`}>
                <IonCheckbox
                    checked={props.activeFilter.gespanneErlaubt}
                    disabled={!props.activeFilter.typePitch}
                    name="gespanneErlaubt"
                    value="gespanneErlaubt"
                    onIonChange={(e) => { 
                      updateFilterAndFetchData({ ...props.activeFilter, gespanneErlaubt: !props.activeFilter.gespanneErlaubt }, "gespanneErlaubt");
                    }}
                ></IonCheckbox>
                <IonLabel className="ion-padding-start">
                  mit Gespannerlaubnis
                </IonLabel>
              </IonItem>

              <IonItem key="type-service" className="filter__item__accordion">
                <IonCheckbox
                  checked={props.activeFilter.typeService}
                  name="type-service"
                  value="type-service"
                  onIonChange={(e) => {
                    updateFilterAndFetchData({ ...props.activeFilter, typeService: !props.activeFilter.typeService }, "typeService");
                  }}
                ></IonCheckbox>
                <IonLabel className="ion-padding-start">
                  reine Entsorgungsstationen
                </IonLabel>
              </IonItem>

              {props.activeFilter.typePitch && (
              <div id="routenplanung-filter-stellplaetze">
                <p className="font__uppercase font__small">Preis</p>
                <IonItem>
                  <IonRange
                    dual-knobs="true"
                    id="price2"
                    onIonKnobMoveEnd={({ detail }) => {
                      updateFilterAndFetchData({ ...props.activeFilter, price: detail.value }, "price");
                    }}
                    value={(() => {
                      const val = {
                        lower: Math.max(0, Math.min(30, Number(props.activeFilter.price?.lower ?? 0))),
                        upper: Math.max(0, Math.min(30, Number(props.activeFilter.price?.upper ?? 30))),
                      };
                      return val;
                    })()}
                    name="price2"
                    min={0}
                    max={30}
                    color="primary"
                    pin={true}
                    pinFormatter={(value) => `${value} €`}
                  >
                    <IonLabel slot="start">Gratis</IonLabel>
                    <IonLabel slot="end">mehr als 30 €</IonLabel>
                  </IonRange>
                </IonItem>

                <p className="font__uppercase font__small">Fahrzeuglänge</p>
                <IonItem className="filter__item__noborder">
                  <IonRange
                    dual-knobs="true"
                    id="vehicle_length"
                    name="vehicle_length"
                    onIonKnobMoveEnd={({ detail }) => {
                      updateFilterAndFetchData({ ...props.activeFilter, vehicle_length: detail.value }, "vehicle_length");
                    }}
                    value={(() => {
                      const val = {
                        lower: Math.max(5, Math.min(15, props.activeFilter.vehicle_length.lower)),
                        upper: Math.max(5, Math.min(15, props.activeFilter.vehicle_length.upper)),
                      };
                      return val;
                    })()}
                    min={5}
                    max={15}
                    color="primary"
                    pin={true}
                    pinFormatter={(value) => `${value} m`}
                  >
                    <IonLabel slot="start">Unter 5 m</IonLabel>
                    <IonLabel slot="end">mehr als 15 m</IonLabel>
                  </IonRange>
                </IonItem>

                <p className="font__uppercase font__small">Anzahl Stellplätze</p>
                <IonItem>
                  <IonRange
                    dual-knobs="true"
                    onIonKnobMoveEnd={({ detail }) => {
                      updateFilterAndFetchData({ ...props.activeFilter, noofpitches: detail.value }, "noofpitches");
                    }}
                    id="noofpitches"
                    name="noofpitches"
                    value={{
                      lower: props.activeFilter.noofpitches.lower,
                      upper: props.activeFilter.noofpitches.upper,
                    }}
                    min="1"
                    max="40"
                    color="primary"
                    pin={true}
                    pinFormatter={(value) => `${value}`}
                  >
                    <IonLabel slot="start">1</IonLabel>
                    <IonLabel slot="end">mehr als 40</IonLabel>
                  </IonRange>
                </IonItem>

                <IonAccordionGroup>
                  <IonAccordion value="first">
                    <IonItem slot="header" className="filter__header__accordion">
                      <IonLabel>
                        <p className="font__uppercase font__small font__red">
                          Versorgung / Entsorgung
                        </p>
                      </IonLabel>
                    </IonItem>
                    <div className="ion-padding" slot="content">
                      {props.versorgung.map((item) => {
                        let itemChecked = false;
                        if (props.activeFilter.features.indexOf(item) !== -1) {
                          itemChecked = true;
                        }
                        return (
                          <>
                            <IonItem
                              key={item}
                              className="filter__item__accordion"
                            >
                              <IonCheckbox
                                checked={itemChecked}
                                name={item}
                                value={item}
                                onIonChange={(e) => {
                                  let newVersorgung = [...props.activeFilter.features];
                                  if (e.detail.checked) {
                                    if (newVersorgung.indexOf(item) === -1) newVersorgung.push(item);
                                  } else {
                                    newVersorgung = newVersorgung.filter(f => f !== item);
                                  }
                                  
                                  // Check if both disposal features are now selected
                                  const hasChemietoiletten = newVersorgung.includes("Chemietoiletten-Entsorgung");
                                  const hasGrauwasser = newVersorgung.includes("Grauwasser-Entsorgung");
                                  const shouldSetTypePitchEntsorgung = hasChemietoiletten && hasGrauwasser;
                                  
                                  updateFilterAndFetchData({ 
                                    ...props.activeFilter, 
                                    features: newVersorgung,
                                    typePitchEntsorgung: shouldSetTypePitchEntsorgung
                                  }, "features");
                                }}
                              ></IonCheckbox>
                              <IonLabel className="ion-padding-start">
                                <p className="font__small font__accordion">
                                  <p className="font__icon font__small icon__accordion">
                                    {item === "Stromanschlüsse"
                                      ? "n"
                                      : item === "Frischwasser"
                                      ? "q"
                                      : item === "WC"
                                      ? "u"
                                      : item === "Dusche"
                                      ? "J"
                                      : item === "Chemietoiletten-Entsorgung"
                                      ? "k"
                                      : item === "Grauwasser-Entsorgung"
                                      ? "l"
                                      : item === "Müll-Entsorgung"
                                      ? "M"
                                      : ""}
                                  </p>
                                  {item}
                                </p>
                              </IonLabel>
                            </IonItem>
                          </>
                        );
                      })}
                    </div>
                  </IonAccordion>

                  <IonAccordion value="second">
                    <IonItem slot="header" className="filter__header__accordion">
                      <IonLabel>
                        <p className="font__uppercase font__small font__red">
                          Ausstattung
                        </p>
                      </IonLabel>
                    </IonItem>

                    <div id="austattung" className="ion-padding" slot="content">
                      {props.austattung.map((item, index) => {
                        let itemChecked = false;
                        if (props.activeFilter.features.indexOf(item) !== -1) {
                          itemChecked = true;
                        }
                        return (
                          <>
                            <IonItem
                              key={item}
                              className="filter__item__accordion"
                            >
                              <IonCheckbox
                                checked={itemChecked}
                                name={item}
                                value={item}
                                onIonChange={(e) => {
                                  let newFeatures = [...props.activeFilter.features];
                                  if (e.detail.checked) {
                                    if (newFeatures.indexOf(item) === -1) newFeatures.push(item);
                                  } else {
                                    newFeatures = newFeatures.filter(f => f !== item);
                                  }
                                  updateFilterAndFetchData({ ...props.activeFilter, features: newFeatures }, "features");
                                }}
                              ></IonCheckbox>

                              <IonLabel className="ion-padding-start">
                                <p className="font__small font__accordion">
                                  <p className="font__icon font__small icon__accordion">
                                    {item === "Einrichtungen für Kinder"
                                      ? "K"
                                      : item === "Rollstuhlgerecht"
                                      ? "f"
                                      : item === "Hunde erlaubt"
                                      ? "h"
                                      : item === "WLAN-Hotspot"
                                      ? "z"
                                      : item === "Gasflaschentausch"
                                      ? "O"
                                      : item === "Schwimmbad"
                                      ? "s"
                                      : item === "Hallenbad"
                                      ? "S"
                                      : item === "Liegewiese"
                                      ? ";"
                                      : item === "Grillplatz"
                                      ? "b"
                                      : item === "Fahrradverleih"
                                      ? "L"
                                      : item === "Restaurants"
                                      ? "p"
                                      : ""}
                                  </p>
                                  {item === "Restaurants" ? "Restaurant" : item}
                                </p>
                              </IonLabel>
                            </IonItem>
                          </>
                        );
                      })}
                    </div>
                  </IonAccordion>
                  <IonAccordion value="third">
                    <IonItem slot="header" className="filter__header__accordion">
                      <IonLabel>
                        <p className="font__uppercase font__small font__red">
                          Untergrund
                        </p>
                      </IonLabel>
                    </IonItem>
                    <div id="underground" className="ion-padding" slot="content">
                      {props.underground.map((item, index) => {
                        let itemChecked = false;
                        if (props.activeFilter.underground.indexOf(item) !== -1) {
                          itemChecked = true;
                        }
                        return (
                          <>
                            <IonItem
                              key={item}
                              className="filter__item__accordion"
                            >
                              <IonCheckbox
                                checked={itemChecked}
                                name={item}
                                value={item}
                                onIonChange={(e) => {
                                  let newUndergrounds = [...props.activeFilter.underground];
                                  if (e.detail.checked) {
                                    if (newUndergrounds.indexOf(item) === -1) newUndergrounds.push(item);
                                  } else {
                                    newUndergrounds = newUndergrounds.filter(f => f !== item);
                                  }
                                  updateFilterAndFetchData({ ...props.activeFilter, underground: newUndergrounds }, "underground");
                                }}
                              ></IonCheckbox>
                              <IonLabel className="ion-padding-start">
                                <p className="font__small font__accordion">
                                  {item}
                                </p>
                              </IonLabel>
                            </IonItem>
                          </>
                        );
                      })}
                    </div>
                  </IonAccordion>
                  <IonAccordion value="fourth">
                    <IonItem slot="header" className="filter__header__accordion">
                      <IonLabel>
                        <p className="font__uppercase font__small font__red">
                          Interessen
                        </p>
                      </IonLabel>
                    </IonItem>
                    <div id="interests" className="ion-padding" slot="content">
                      {props.interestsCat.map((cat) => {
                        return (
                          <>
                            <h5>{cat}</h5>
                            {Object.entries(props.interests[cat]).map(
                              (subitem) => {
                                var subkey = subitem[0];
                                let itemChecked = false;
                                if (
                                  props.activeFilter.interests.indexOf(subkey) !== -1
                                ) {
                                  itemChecked = true;
                                }
                                return (
                                  <>
                                    <IonItem
                                      key={subkey}
                                      className="filter__item__accordion"
                                    >
                                      <IonCheckbox
                                        checked={itemChecked}
                                        name={subkey}
                                        value={subkey}
                                        onIonChange={(e) => {
                                          let newInterests = [...props.activeFilter.interests];
                                          if (e.detail.checked) {
                                            if (newInterests.indexOf(subkey) === -1) newInterests.push(subkey);
                                          } else {
                                            newInterests = newInterests.filter(f => f !== subkey);
                                          }
                                          updateFilterAndFetchData({ ...props.activeFilter, interests: newInterests }, "interests");
                                        }}
                                      ></IonCheckbox>
                                      <IonLabel className="ion-padding-start">
                                        <p className="font__small font__accordion">
                                          {subkey}
                                        </p>
                                      </IonLabel>
                                    </IonItem>
                                  </>
                                );
                              }
                            )}
                          </>
                        );
                      })}
                    </div>
                  </IonAccordion>
                </IonAccordionGroup>
              </div>
              )}
            </IonContent>
          </IonModal>
      </div>
    </div>
  ) : (
    <div></div>
  );
}

export default Filter;
